const tintColorLight = '#FCFCFC';
const tintColorDark = '#fcfcfc';

export default {
  light: {
    text: '#000',
    background: '#fff',
    tint: tintColorLight,
    tabIconDefault: '#343756',
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: '#fff',
    background: '#070816',
    tint: tintColorDark,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorDark,
  },
};
